<template>
    <div class="alert alert-danger" data-dusk="validation-errors" v-show="hasErrors">
        <ul>
            <li v-for="error in flatErrors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: { errors: Object },

        computed: {
            flatErrors() {
                return _(this.errors)
                    .values()
                    .flatten()
                    .value();
            },

            hasErrors() {
                return !! this.flatErrors.length;
            }
        }
    }
</script>
